import { Address } from './address';
import { ProdutosCarrinho } from './produtos-carrinho.model';

export class StateManager {
    public endereco: Address = new Address();
    public quantidadeCarrinho: number;
    public produtosCarrinho: ProdutosCarrinho = new ProdutosCarrinho();
}
